export const isEmpty = (value?: unknown) => {
  if (typeof value === 'string') {
    return !value ? 'Field must not be empty' : ''
  }

  if (typeof value === 'number') {
    return isNaN(value) ? 'Field must not be empty' : ''
  }

  if (Array.isArray(value)) {
    return value.length ? '' : 'Field must not be empty'
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? 'Field must not be empty' : ''
  }

  if (value === null || value === undefined) {
    return 'Field must not be empty'
  }

  return 'Invalid value type'
}
